import { callGetApi, callPutApi, callPostApi, callDeleteApi } from '../apiCallerProxy';
import { creativesApiFactory } from './creativesApiFactory';

export * from './hooks';
export default creativesApiFactory({ callGetApi, callPutApi, callPostApi, callDeleteApi });
